import FuseLoading from '@fuse/core/FuseLoading';
import ErrorBoundary from '@fuse/utils/ErrorBoundary';
import {FuseRouteConfigType, FuseRoutesType} from '@fuse/utils/FuseUtils';
import {layoutConfigOnlyMain} from 'app/configs/layoutConfigTemplates';
import settingsConfig from 'app/configs/settingsConfig';
import {Navigate} from 'react-router';

import App from '../App';

const configModules: Record<string, unknown> = import.meta.glob(
  '/src/app/main/**/*Route.tsx',
  {eager: true},
);

export const mainRoutes: FuseRouteConfigType[] = Object.keys(configModules)
  .map(modulePath => {
    const moduleConfigs = (
      configModules[modulePath] as {
        default: FuseRouteConfigType | FuseRouteConfigType[];
      }
    ).default;
    return Array.isArray(moduleConfigs) ? moduleConfigs : [moduleConfigs];
  })
  .flat();

const routes = [
  {
    path: '/',
    element: <App />,
    auth: settingsConfig.defaultAuth,
    errorElement: <ErrorBoundary />,
    children: [
      ...mainRoutes,
      {
        path: 'loading',
        element: <FuseLoading />,
        settings: {layout: layoutConfigOnlyMain},
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
] as FuseRoutesType;

export default routes;
